// App URL Params Reducer
export const SET_BRAND = 'SET_BRAND';
export const SET_SERVER = 'SET_SERVER';
export const SET_PATH_NAME = 'SET_PATH_NAME';
export const SET_ADOBE_READY_FLAG = 'SET_ADOBE_READY_FLAG';
export const TOGGLE_OFF_FIRST_LOAD = 'TOGGLE_OFF_FIRST_LOAD';

// Year Make Model Reducer
export const SET_YEARS = 'SET_YEARS';
export const SET_MAKES = 'SET_MAKES';
export const SET_MODELS = 'SET_MODELS';
export const SET_TRIMS = 'SET_TRIMS';
export const SET_SIZES = 'SET_SIZES';
export const SET_ZIPCODE = 'SET_ZIPCODE';
export const SET_SELECT_YEAR = 'SET_SELECT_YEAR';
export const SET_SELECT_MAKE = 'SET_SELECT_MAKE';
export const SET_SELECT_MODEL = 'SET_SELECT_MODEL';
export const SET_SELECT_SIZE = 'SET_SELECT_SIZE';
export const SET_SELECT_TRIM = 'SET_SELECT_TRIM';

//Dealer Locator
export const SET_DEALER_FLAG = 'SET_DEALER_FLAG';
export const CLEAR_SELECTED_DEALER = 'CLEAR_SELECTED_DEALER';
export const SELECT_DEALER = 'SELECT_DEALER';
export const DEALER_NAME_SEARCH = 'DEALER_NAME_SEARCH';
export const SET_DEALERS = 'SET_DEALERS';
export const SET_DEALER_SERVICES = 'SET_DEALER_SERVICES';
export const SET_DEALER_NAME = 'SET_DEALER_NAME';
export const SET_DEALER_ENROLLMENT = 'SET_DEALER_ENROLLMENT';
export const SET_CURRENT_LAT_LNG = 'SET_CURRENT_LAT_LNG';
export const CLEAR_CURRENT_LAT_LNG = 'CLEAR_CURRENT_LAT_LNG';
export const SET_SEARCH_LOCATION = 'SET_SEARCH_LOCATION';
export const SET_SERVICE_OPTIONS = 'SET_SERVICE_OPTIONS';
export const SHOW_MORE = 'SHOW_MORE';
export const SET_REDUX_MARKERS = 'SET_REDUX_MARKERS';
export const ADD_REDUX_MARKER = 'ADD_REDUX_MARKER';
export const SET_BRANDS_LIST = 'SET_BRANDS_LIST';
export const SET_SPEED_RATING_LIST = 'SET_SPEED_RATING_LIST';
export const SET_LOADS_LIST = 'SET_LOADS_LIST';
export const SET_TIRE_TYPES_LIST = 'SET_TIRE_TYPES_LIST';
export const SET_CLASSIFICATION = 'SET_CLASSIFICATION';
export const SET_DEALER_SERVICES_FLAG = 'SET_DEALER_SERVICES_FLAG';
export const SET_GOOGLE_MAPS_LOOKUP_ERROR = 'SET_GOOGLE_MAPS_LOOKUP_ERROR';
export const SET_DEALER_LOCATOR_RENDER_FLAG = 'SET_DEALER_LOCATOR_RENDER_FLAG';

//Search Results
export const SET_BAC = 'SET_BAC';
export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';
export const SET_SEARCH_RESULT_BRAND = 'SET_SEARCH_RESULT_BRAND';
export const SET_INDEX = 'SET_INDEX';
export const INCREMENT_SEARCH_QUANTITY = 'INCREMENT_SEARCH_QUANTITY';
export const DECREMENT_SEARCH_QUANTITY = 'DECREMENT_SEARCH_QUANTITY';
export const SET_SEARCH_QUANTITY = 'SET_SEARCH_QUANTITY';
export const RESET_SEARCH_QUANTITIES = 'RESET_SEARCH_QUANTITIES';
export const SET_SEARCH_SORT = "SET_SEARCH_SORT";
export const SET_FILTERED_RESULT = 'SET_FILTERED_RESULT';
export const SET_SPINNER = "SET_SPINNER";
export const UPDATE_RESULTS = 'UPDATE_RESULTS';
export const SET_ORIGINAL_EQUIPMENT = 'SET_ORIGINAL_EQUIPMENT';
export const ADD_CHECKBOX_TIRE = 'ADD_CHECKBOX_TIRE';
export const REMOVE_CHECKBOX_TIRE = 'REMOVE_CHECKBOX_TIRE';
export const CLEAR_CHECKBOX_TIRES = 'CLEAR_CHECKBOX_TIRES';
export const NEW_TIRE = 'NEW_TIRE';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const SET_FILTER_DIALOG_FLAG = 'SET_FILTER_DIALOG_FLAG';
export const SET_TIRE_SIZE_DIALOG_FLAG = 'SET_TIRE_SIZE_DIALOG_FLAG';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SET_CLEAR_CHECKBOX_SNACKBAR = 'SET_CLEAR_CHECKBOX_SNACKBAR';
export const SET_AXIOS_CANCEL_SOURCE = 'SET_AXIOS_CANCEL_SOURCE';

//Cart
export const ADD_TIRE = 'ADD_TIRE';
export const ADD_TIRE_QUANTITY = 'ADD_TIRE_QUANTITY';
export const INCREMENT_CART_QUANTITY = 'INCREMENT_CART_QUANTITY';
export const DECREMENT_CART_QUANTITY = 'DECREMENT_CART_QUANTITY';
export const REMOVE_TIRE = 'REMOVE_TIRE';
export const SET_ADDITIONAL_SERVICES = 'SET_ADDITIONAL_SERVICES';
export const SET_INSTALLATION = 'SET_INSTALLATION';
export const RECALCULATE = 'RECALCULATE';
export const SET_BLOB = 'SET_BLOB';
export const CLEAR_CART = 'CLEAR_CART';
